import styled from 'styled-components';
import AntdModal from '../../../../../AntdModal';

const StyledRejectExpenseModal = styled(AntdModal)`
  .ant-modal-content {
    .ant-modal-body {
      padding-top: 40px;
      p {
        margin-bottom: 0;
      }
    }
  }
`;

export {
  StyledRejectExpenseModal
};
